import useSWR from 'swr';

import swrListPublishesForPipelineFetcher from '../../utils/api_functions/publishListPublishesForPipeline';

const useListPublishesForPipeline = (pipelineId, newPublish, isEdgeEnabled, isEdgePublishingEnabled) => {
  const {
    data, error, isLoading
  } = useSWR(pipelineId !== null && (isEdgeEnabled || isEdgePublishingEnabled) ? [pipelineId, newPublish, 'publish-list'] : null, swrListPublishesForPipelineFetcher, {
    refreshInterval: newPublish ? 1000 : 30000
  })

  return ({
    data,
    error,
    isLoading
  })   
}

export default useListPublishesForPipeline
